"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1535],{

/***/ 84456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ PriceInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6686);
/* harmony import */ var _libs_useTheme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5779);





/**
 * Primary UI component for text input
 */ const PriceInput = (param)=>{
    let { label , placeholder , value ="" , onChange , className , hint , validations , required , currencySymbol ="\xa3" , labelBgColour , textColour , border ="border" , maxValue  } = param;
    const { theme , StaticColours  } = (0,_libs_useTheme__WEBPACK_IMPORTED_MODULE_4__/* .useTheme */ .Fg)();
    const errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_3__/* .validate */ .G)(value, validations);
    const [hintColor, setHintColor] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(theme.textColour);
    const [dynamicClasses, setDynamicClasses] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [timer, setTimer] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const input = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: "relative flex items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute ml-4 text-sm",
                children: currencySymbol
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                required: required,
                value: value,
                onChange: (e)=>{
                    let val = e.target.value;
                    const isInvalid = (0,_Validations__WEBPACK_IMPORTED_MODULE_3__/* .validate */ .G)(e.target.value, validations) !== "";
                    if (maxValue && parseInt(e.target.value) > maxValue) {
                        e.target.value = maxValue === null || maxValue === void 0 ? void 0 : maxValue.toString();
                        if (!timer) {
                            const timeout = setTimeout(()=>{
                                setHintColor(theme.textColour);
                                setDynamicClasses("");
                                clearTimeout(timer);
                                setTimer(undefined);
                            }, 3000);
                            setHintColor(StaticColours.forumm_red);
                            setDynamicClasses("animate-shake-input");
                            setTimer(timeout);
                        }
                        value = maxValue.toString();
                        val = maxValue.toString();
                    }
                    onChange && onChange(val, isInvalid);
                },
                type: "number",
                autoComplete: "on",
                placeholder: placeholder,
                className: "w-full transition-all bg-transparent ".concat(border, " ").concat(errorMessage ? "text-red-500 border-red-500" : "", " rounded-2xl pl-8 pr-4 py-4 text-sm outline-none placeholder-gray-500")
            })
        ]
    });
    const bgHint = theme.type === "DARK" ? "bg-midnight-dark" : "bg-white";
    var ref;
    const backgroundColour = (ref = labelBgColour !== null && labelBgColour !== void 0 ? labelBgColour : theme === null || theme === void 0 ? void 0 : theme.backgroundColourSecondary) !== null && ref !== void 0 ? ref : "#0D0E11";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
        className: "".concat([
            "flex flex-col my-4",
            className
        ].join(" "), "  ").concat(dynamicClasses),
        style: {
            color: textColour
        },
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "absolute text-sm mb-2 ml-2 z-10 ".concat(backgroundColour, " ").concat(required ? "pl-2" : "px-2", " transition-all ").concat(errorMessage ? "text-red-500" : ""),
                style: {
                    background: backgroundColour,
                    transform: "translateY(-50%)"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        backgroundColor: backgroundColour
                    },
                    className: "z-10 ".concat(required ? "after:content-['*'] after:mx-2 after:text-red-500" : ""),
                    children: label
                })
            }),
            input,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-1 mb-4 ml-2 text-xs",
                style: {
                    color: hintColor
                },
                children: hint
            })
        ]
    });
};


/***/ }),

/***/ 49532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gu": function() { return /* binding */ validate; },
/* harmony export */   "HO": function() { return /* binding */ DonationRules; },
/* harmony export */   "f5": function() { return /* binding */ shouldShowField; },
/* harmony export */   "mV": function() { return /* binding */ getCreateEventError; },
/* harmony export */   "nA": function() { return /* binding */ CreateEventSection; },
/* harmony export */   "sl": function() { return /* binding */ getValidationRules; },
/* harmony export */   "zx": function() { return /* binding */ isFieldRequired; }
/* harmony export */ });
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68240);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50160);


const shouldShowField = (rule)=>{
    if (!rule) return false;
    if (!Array.isArray(rule)) return false;
    if (rule[1] === false) return true;
    if (rule[1] === true) return true;
    if (rule[1] === null) return false;
    return false;
};
const isFieldRequired = (rule)=>{
    if (!rule) return false;
    if (!Array.isArray(rule)) return false;
    if (typeof rule[1] === "function") return false;
    return !!rule[1];
};
// Rules are formatted as a tuple to denote the target field and its rule
// true   = shown & required
// false  = shown & not required
// null   = hidden & not required
const FundraiserEventRules = [
    [
        "event_title",
        true
    ],
    [
        "event_shortDescription",
        true
    ],
    [
        "event_registrationCloseDateTime",
        false
    ],
    [
        "event_startDateTime",
        false
    ],
    [
        "event_endDateTime",
        false
    ],
    [
        "event_description",
        false
    ],
    [
        "event_publiclyListed",
        false
    ],
    [
        "event_eventLocation",
        null
    ],
    [
        "tickets_*",
        null
    ],
    [
        "fundraising_title",
        true
    ],
    [
        "fundraising_title",
        (f)=>f.length > 0
    ],
    [
        "fundraising_description",
        true
    ],
    [
        "fundraising_description",
        (f)=>f.length > 0
    ],
    [
        "fundraising_goal",
        true
    ],
    [
        "fundraising_goal",
        (f)=>f > 0
    ],
    [
        "speakers_*",
        null
    ],
    [
        "stages_*",
        null
    ],
    [
        "sessions_*",
        null
    ],
    [
        "attendees_*",
        null
    ],
    [
        "sponsors_*",
        null
    ],
    [
        "breakoutRooms_*",
        null
    ],
    [
        "communications_socials",
        false
    ],
    [
        "communications_announcements",
        null
    ],
    [
        "notifications_*",
        false
    ],
    [
        "ondemandContent_*",
        null
    ]
];
const OnlineEventRules = [
    [
        "event_title",
        true,
        "Please give your event a title"
    ],
    [
        "event_shortDescription",
        true,
        "Please add a short description of your event"
    ],
    [
        "event_registrationCloseDateTime",
        true,
        "Please add a valid close date & time for your event registration"
    ],
    [
        "event_startDateTime",
        true,
        "Please add a valid start date & time for your event"
    ],
    [
        "event_endDateTime",
        true,
        "Please add a valid end date & time for your event"
    ],
    [
        "event_description",
        false
    ],
    [
        "event_publiclyListed",
        false
    ],
    [
        "event_eventLocation",
        null
    ],
    [
        "tickets_*",
        true,
        "Please add atleast 1 ticket for this event"
    ],
    [
        "tickets_*",
        (f)=>f.length > 0,
        "Please add atleast 1 ticket for this event"
    ],
    [
        "fundraising_title",
        null
    ],
    [
        "fundraising_description",
        null
    ],
    [
        "fundraising_goal",
        null
    ],
    [
        "speakers_*",
        false
    ],
    [
        "stages_*",
        false
    ],
    [
        "sessions_*",
        false
    ],
    [
        "attendees_*",
        false
    ],
    [
        "sponsors_*",
        false
    ],
    [
        "breakoutRooms_*",
        false
    ],
    [
        "communications_socials",
        false
    ],
    [
        "communications_announcements",
        false
    ],
    [
        "notifications_*",
        false
    ],
    [
        "ondemandContent_*",
        false
    ]
];
const InpersonEventRules = [
    [
        "event_title",
        true,
        "Please give your event a title"
    ],
    [
        "event_shortDescription",
        true,
        "Please add a short description of your event"
    ],
    [
        "event_registrationCloseDateTime",
        true,
        "Please add a valid close date & time for your event registration"
    ],
    [
        "event_startDateTime",
        true,
        "Please add a valid start date & time for your event"
    ],
    [
        "event_endDateTime",
        true,
        "Please add a valid end date & time for your event"
    ],
    [
        "event_description",
        false
    ],
    [
        "event_publiclyListed",
        false
    ],
    [
        "event_eventLocation",
        false
    ],
    [
        "tickets_*",
        true,
        "Please add atleast 1 ticket for this event"
    ],
    [
        "tickets_*",
        (f)=>f.length > 0,
        "Please add atleast 1 ticket for this event"
    ],
    [
        "fundraising_title",
        null
    ],
    [
        "fundraising_description",
        null
    ],
    [
        "fundraising_goal",
        null
    ],
    [
        "speakers_*",
        false
    ],
    [
        "stages_*",
        false
    ],
    [
        "sessions_*",
        false
    ],
    [
        "attendees_*",
        false
    ],
    [
        "sponsors_*",
        false
    ],
    [
        "breakoutRooms_*",
        null
    ],
    [
        "communications_socials",
        false
    ],
    [
        "communications_announcements",
        false
    ],
    [
        "notifications_*",
        false
    ],
    [
        "ondemandContent_*",
        null
    ]
];
const DonationRules = [
    [
        "currency",
        false
    ],
    [
        "amount",
        true
    ],
    [
        "donator_dob",
        false
    ],
    [
        "donator_title",
        false
    ],
    [
        "donator_firstName",
        true
    ],
    [
        "donator_lastName",
        true
    ],
    [
        "donator_email",
        true
    ],
    [
        "message",
        false
    ],
    [
        "donatedAt",
        false
    ],
    [
        "program",
        false
    ],
    [
        "payment_method",
        true
    ],
    [
        "payment_isRecurring",
        false
    ],
    [
        "payment_coverPlatformFee",
        false
    ],
    [
        "payment_coverTrxFee",
        false
    ],
    [
        "payment_giftAid",
        false
    ],
    [
        "payment_giftAidConfirm",
        false
    ],
    [
        "payment_card_details_number",
        false
    ],
    [
        "payment_card_details_exp_date",
        false
    ],
    [
        "payment_card_details_CVC",
        false
    ],
    [
        "payment_card_details_post_code",
        false
    ],
    [
        "payment_card_details_address",
        false
    ],
    [
        "paymentType",
        false
    ],
    [
        "selectedRecurrency",
        false
    ],
    [
        "homeAddress",
        true
    ],
    [
        "visibility",
        true
    ],
    [
        "directDebit_name",
        false
    ],
    [
        "directDebit_number",
        false
    ],
    [
        "directDebit_sort",
        false
    ],
    [
        "directDebit_confirmDirectDebit",
        false
    ],
    [
        "addressLine1",
        true
    ],
    [
        "addressCity",
        true
    ],
    [
        "addressPostalCode",
        true
    ],
    [
        "addressCountry",
        true
    ],
    [
        "addressPhone",
        false
    ],
    [
        "allowEmailContact",
        false
    ],
    [
        "allowTelephoneContact",
        false
    ]
];
const getValidationRules = (type)=>{
    if (!type) return OnlineEventRules;
    if (type === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .EventType.Online */ .tw.Online) return OnlineEventRules;
    if (type === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .EventType.InPerson */ .tw.InPerson) return InpersonEventRules;
    if (type === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .EventType.Fundraiser */ .tw.Fundraiser) return FundraiserEventRules;
    if (type === "Donation") return DonationRules;
    return OnlineEventRules;
};
const validate = (data, rules)=>{
    if (!data || !rules) return {
        error: {
            step: "Unknown",
            message: "Please complete all required fields."
        }
    };
    const fieldsToValidate = (0,_util__WEBPACK_IMPORTED_MODULE_1__/* .flatten */ .xH)(data);
    for (let rulePair of rules){
        const ruleKey = rulePair[0];
        const rule = rulePair[1];
        var ref;
        const errorMessage = (ref = rulePair[2]) !== null && ref !== void 0 ? ref : "Please complete all required fields.";
        const isPattern = ruleKey.endsWith("*");
        let keysToCheck = isPattern ? Object.keys(fieldsToValidate).filter((key)=>key.startsWith(ruleKey.slice(0, -1))) : [
            ruleKey
        ];
        if (isPattern) {
            const originalKey = ruleKey.slice(0, -2);
            if (typeof rule !== "function" && rule === true && data.hasOwnProperty(originalKey) && Array.isArray(data[originalKey]) && data[originalKey].length === 0) {
                return {
                    error: {
                        step: originalKey,
                        message: errorMessage
                    }
                };
            }
        }
        for (let key of keysToCheck){
            const target = fieldsToValidate[key];
            // console.log(`[${key}]: ${target} => ${typeof target}`)
            if (typeof target === "boolean" || !!target) {
                if (typeof rule === "boolean") {
                    if (rule && target.length < 1) {
                        return {
                            error: {
                                step: key.split("_")[0],
                                message: errorMessage
                            }
                        };
                    }
                }
                if (typeof rule === "function") {
                    if (!rule(target.toString())) {
                        return {
                            error: {
                                step: key.split("_")[0],
                                message: errorMessage
                            }
                        };
                    }
                }
            } else if (!isPattern) {
                if (rule) {
                    return {
                        error: {
                            step: key.split("_")[0],
                            message: errorMessage
                        }
                    };
                }
            }
        }
    }
    return {
        error: undefined
    };
};
var CreateEventSection;
(function(CreateEventSection) {
    CreateEventSection["DETAILS"] = "Details";
    CreateEventSection["REGISTRATION"] = "Registration";
    CreateEventSection["FUNDRAISING"] = "Fundraising";
    CreateEventSection["SPEAKERS"] = "Speakers";
    CreateEventSection["STAGES"] = "Stages";
    CreateEventSection["SESSIONS"] = "Sessions";
    CreateEventSection["ATTENDEES"] = "Attendees";
    CreateEventSection["PARTNERS"] = "Partners";
    CreateEventSection["BREAKOUT_ROOMS"] = "Breakout Rooms";
    CreateEventSection["COMMUNICATIONS"] = "Communications";
    CreateEventSection["NOTIFICATIONS"] = "Notifications";
    CreateEventSection["ON_DEMAND_CONTENT"] = "On Demand Content";
})(CreateEventSection || (CreateEventSection = {}));
const CreateEventSectionError = {
    [CreateEventSection.DETAILS]: {
        section: CreateEventSection.DETAILS,
        error: "Please complete the event details section before moving on."
    },
    [CreateEventSection.REGISTRATION]: {
        section: CreateEventSection.REGISTRATION,
        error: "Please complete the registration section before moving on."
    },
    [CreateEventSection.FUNDRAISING]: {
        section: CreateEventSection.FUNDRAISING,
        error: "Please complete the fundraising section before moving on."
    },
    [CreateEventSection.SPEAKERS]: {
        section: CreateEventSection.SPEAKERS,
        error: "Please add atleast one speaker before moving on."
    },
    [CreateEventSection.STAGES]: {
        section: CreateEventSection.STAGES,
        error: "Please add ateleast one stage before moving on."
    },
    [CreateEventSection.SESSIONS]: {
        section: CreateEventSection.SESSIONS,
        error: "Please add atleast one session before moving on."
    },
    [CreateEventSection.ATTENDEES]: {
        section: CreateEventSection.ATTENDEES,
        error: "Please complete the attendee section before moving on."
    },
    [CreateEventSection.PARTNERS]: {
        section: CreateEventSection.PARTNERS,
        error: "Please complete the partner section before moving on."
    },
    [CreateEventSection.BREAKOUT_ROOMS]: {
        section: CreateEventSection.BREAKOUT_ROOMS,
        error: "Please complete the breakout room section before moving on."
    },
    [CreateEventSection.COMMUNICATIONS]: {
        section: CreateEventSection.COMMUNICATIONS,
        error: "Please complete the communication section before moving on."
    },
    [CreateEventSection.NOTIFICATIONS]: {
        section: CreateEventSection.NOTIFICATIONS,
        error: "Please complete the notifications section before moving on."
    },
    [CreateEventSection.ON_DEMAND_CONTENT]: {
        section: CreateEventSection.ON_DEMAND_CONTENT,
        error: "Please complete the on-demand content section before moving on."
    }
};
const CreateEventSectionPrerequisites = {
    [CreateEventSection.DETAILS]: [],
    [CreateEventSection.REGISTRATION]: [
        CreateEventSectionError[CreateEventSection.DETAILS]
    ],
    [CreateEventSection.FUNDRAISING]: [
        CreateEventSectionError[CreateEventSection.DETAILS]
    ],
    [CreateEventSection.SPEAKERS]: [
        CreateEventSectionError[CreateEventSection.DETAILS]
    ],
    [CreateEventSection.STAGES]: [
        CreateEventSectionError[CreateEventSection.DETAILS],
        CreateEventSectionError[CreateEventSection.SPEAKERS]
    ],
    [CreateEventSection.SESSIONS]: [
        CreateEventSectionError[CreateEventSection.DETAILS],
        CreateEventSectionError[CreateEventSection.SPEAKERS],
        CreateEventSectionError[CreateEventSection.STAGES]
    ],
    [CreateEventSection.ATTENDEES]: [
        CreateEventSectionError[CreateEventSection.DETAILS]
    ],
    [CreateEventSection.PARTNERS]: [
        CreateEventSectionError[CreateEventSection.DETAILS]
    ],
    [CreateEventSection.BREAKOUT_ROOMS]: [
        CreateEventSectionError[CreateEventSection.DETAILS]
    ],
    [CreateEventSection.COMMUNICATIONS]: [
        CreateEventSectionError[CreateEventSection.DETAILS]
    ],
    [CreateEventSection.NOTIFICATIONS]: [
        CreateEventSectionError[CreateEventSection.DETAILS]
    ],
    [CreateEventSection.ON_DEMAND_CONTENT]: [
        CreateEventSectionError[CreateEventSection.DETAILS]
    ]
};
const getCreateEventError = (section, formData)=>{
    var ref, ref1, ref2, ref3, ref4;
    const defaultError = {
        section: undefined,
        error: "Please complete the previous section before moving forward."
    };
    const payload = [];
    const completedSections = {
        [CreateEventSection.DETAILS]: false,
        [CreateEventSection.REGISTRATION]: false,
        [CreateEventSection.FUNDRAISING]: false,
        [CreateEventSection.SPEAKERS]: false,
        [CreateEventSection.STAGES]: false,
        [CreateEventSection.SESSIONS]: false,
        [CreateEventSection.ATTENDEES]: false,
        [CreateEventSection.PARTNERS]: false,
        [CreateEventSection.BREAKOUT_ROOMS]: false,
        [CreateEventSection.COMMUNICATIONS]: false,
        [CreateEventSection.NOTIFICATIONS]: false,
        [CreateEventSection.ON_DEMAND_CONTENT]: false
    };
    if (!section || !formData) return [
        defaultError
    ];
    if (formData === null || formData === void 0 ? void 0 : (ref = formData.event) === null || ref === void 0 ? void 0 : ref.title) completedSections[CreateEventSection.DETAILS] = true;
    if ((formData === null || formData === void 0 ? void 0 : formData.tickets) && (formData === null || formData === void 0 ? void 0 : (ref1 = formData.tickets) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) completedSections[CreateEventSection.REGISTRATION] = true;
    if ((formData === null || formData === void 0 ? void 0 : formData.fundraising) && (formData === null || formData === void 0 ? void 0 : (ref2 = formData.fundraising) === null || ref2 === void 0 ? void 0 : ref2.goal)) completedSections[CreateEventSection.FUNDRAISING] = true;
    if ((formData === null || formData === void 0 ? void 0 : formData.speakers) && (formData === null || formData === void 0 ? void 0 : (ref3 = formData.speakers) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) completedSections[CreateEventSection.SPEAKERS] = true;
    if ((formData === null || formData === void 0 ? void 0 : formData.stages) && (formData === null || formData === void 0 ? void 0 : (ref4 = formData.stages) === null || ref4 === void 0 ? void 0 : ref4.length) > 0) completedSections[CreateEventSection.STAGES] = true;
    if ((formData === null || formData === void 0 ? void 0 : formData.sessions) && formData.sessions.length > 0) completedSections[CreateEventSection.SESSIONS] = true;
    if ((formData === null || formData === void 0 ? void 0 : formData.attendees) && formData.attendees.length > 0) completedSections[CreateEventSection.ATTENDEES] = true;
    if ((formData === null || formData === void 0 ? void 0 : formData.sponsors) && formData.sponsors.length > 0) completedSections[CreateEventSection.PARTNERS] = true;
    if ((formData === null || formData === void 0 ? void 0 : formData.breakoutRooms) && formData.breakoutRooms.length > 0) completedSections[CreateEventSection.BREAKOUT_ROOMS] = true;
    if ((formData === null || formData === void 0 ? void 0 : formData.notifications) && formData.notifications.length > 0) completedSections[CreateEventSection.NOTIFICATIONS] = true;
    if ((formData === null || formData === void 0 ? void 0 : formData.ondemandContent) && formData.ondemandContent.length > 0) completedSections[CreateEventSection.ON_DEMAND_CONTENT] = true;
    if (CreateEventSectionPrerequisites[section].length > 0) {
        CreateEventSectionPrerequisites[section].forEach((val)=>{
            if (!completedSections[val.section]) payload.push(val);
        });
    }
    return payload;
};


/***/ })

}]);